/**
 * element-ui 共通方法
 * zxm
 * 2021-10-11
 */

var system = {
  /**
   * 确认弹窗
   * @param {*} e  this
   * @param {*} message 提示信息
   * @param {*} type 提示类型
   * @param {*} callback  回调
   * 使用方法  this.system.confirm(this,messsge,type,function(res,err){})
   */
  confirm: (e, message, type, callback) => {
    e.$confirm(message, "温馨提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: type
    })
      .then(() => {
        callback(true, null);
      })
      .catch(err => {
        callback(null, true);
      });
  },
  /**
   * 表单验证
   * 使用方法
   * rules:{
   * rule:[this.system.rules.required,this.system.rules.changeRequired]
   * }
   */
  rules: {
    required: { required: true, message: "请输入必填项", trigger: "blur" }, //必填项
    changeRequired: {
      required: true,
      message: "请选择必填项",
      trigger: "change"
    }, //改变必选
    dateRequired: {
      type: "date",
      required: true,
      message: "请选择日期",
      trigger: "change"
    }, //时间必选
    arrayRequired: {
      type: "array",
      required: true,
      message: "请至少选择一个",
      trigger: "change"
    }, //至少选择一个
    len20: {
      min: 1,
      max: 20,
      required: true,
      message: "长度在1到20个字符",
      trigger: "blur"
    }, //长度限制1-20
    len100: {
      min: 1,
      max: 100,
      required: true,
      message: "长度在1到100个字符",
      trigger: "blur"
    }, //长度限制1-100
    len500: {
      min: 1,
      max: 500,
      required: true,
      message: "长度在1到500个字符",
      trigger: "blur"
    }, //长度限制1-500
    phone: {
      required: true,
      validator: (rule, value, callback) => {
        if (!value) {
          callback(new Error("联系电话不能为空"));
        } else {
          const mobilePhone = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
          //座机格式
          const telePhone = /^((0\d{2,3})-)?(\d{7,8})$/;

          const isPhone = !mobilePhone.test(value) && !telePhone.test(value);
          //
          if (isPhone) {
            callback(new Error("请输入正确的联系电话"));
          } else {
            callback();
          }
        }
      },
      trigger: "blur"
    }, //手机号验证
    email: {
      required: true,
      validator: (rule, value, callback) => {
        if (!value) {
          callback(new Error('收件邮箱不能为空'));
        } else {
          const reg = /^([A-Za-z0-9_\-.\u4e00-\u9fa5])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/;
          const isEmail = reg.test(value);
          if (!isEmail) {
            callback(new Error("请输入正确的收件邮箱"));
          } else {
            callback();
          }
        }
      },
      trigger: "blur"
    }, //邮箱验证
    taxpayer: {
      required: true,
      validator: (rule, value, callback) => {
        if (!value) {
          callback(new Error("纳税人识别号不能为空"));
        } else {
          const reg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/;
          const isTrue = reg.test(value);
          if (!isTrue) {
            callback(new Error("请输入正确的纳税人识别号"));
          } else {
            callback();
          }
        }
      },
      trigger: "blur"
    }, // 纳税人识别号
    idCard: {
      validator: (rule, value, callback) => {
        if (!value) {
          callback();
        } else {
          const reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
          const isEmail = reg.test(value);
          if (!isEmail) {
            callback(new Error("请输入正确的身份证号！"));
          } else {
            callback();
          }
        }
      },
      trigger: "blur"
    }, // 身份证验证
    bankCard: {
      required: true,
      validator: (rule, value, callback) => {
        if (!value) {
          callback(new Error("银行账号不能为空"));
        } else {
          const reg = /^\d{9,24}$/;
          const isTrue = reg.test(value);
          if (!isTrue) {
            callback(new Error("请输入正确的银行账号"));
          } else {
            callback();
          }
        }
      },
      trigger: "blur"
    }, // 银行卡
    numberSix: {
      validator: (rule, value, callback) => {
        if (!value) {
          callback(new Error("请输入必填项"));
        } else {
          const reg = /^\d{1,}$/;
          const isNumber = reg.test(value);
          if (!isNumber) {
            callback(new Error("只能包含数字！"));
          } else {
            callback();
          }
        }
      },
      trigger: "blur"
    }, //限制只能输入数字
    dotNumberSix: {
      validator: (rule, value, callback) => {
        if (!value) {
          callback();
        } else {
          const reg = /^\d+\.\d+$|^\d{1,}$/;
          const isNumber = reg.test(value);
          if (!isNumber) {
            callback(new Error("只能输入整数与小数！"));
          } else {
            callback();
          }
        }
      },
      trigger: "blur"
    },
    age: {
      validator: (rule, value, callback) => {
        if (!value) {
          callback(new Error("请输入必填项"));
        } else {
          const reg = /[^\d]/g;
          const isNumber = reg.test(value);
          if (isNumber) {
            callback(new Error("请输入正确年龄！"));
          } else {
            callback();
          }
        }
      },
      trigger: "blur"
    }, // 年龄限制只能输入数字
    numberDot: {
      validator: (rule, value, callback) => {
        if (!value) {
          callback(new Error("请输入必填项"));
        } else {
          if (value < 0 || value > 100) {
            callback(new Error("请输入0到100之间的数字！"));
          } else {
            const reg = /^\d*?(\.?\d{1,6})$/g;
            const isNumber = reg.test(value);
            if (!isNumber) {
              callback(
                new Error("请输入0到100之间的数字，并且小数不超过6位！")
              );
            } else {
              callback();
            }
          }
        }
      },
      trigger: "blur"
    }, // 限制小数点后位数
    numberDot2: {
      validator: (rule, value, callback) => {
        if (!value) {
          callback(new Error("请输入必填项"));
        } else {
          const reg = /^\d*?(\.?\d{1,2})$/g;
          const isNumber = reg.test(value);
          if (!isNumber) {
            callback(new Error("请输入数字，并且小数不超过2位！"));
          } else {
            callback();
          }
        }
      },
      trigger: "blur"
    } // 限制小数点后位数
  }
};
export default system;



// WEBPACK FOOTER //
// ./src/utils/system.js